import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'conversationTypeIcon', standalone: true, pure: true })
export class ConversationTypeIconPipe implements PipeTransform {
	transform(type: ChatConversationType): string {
		return type === 'BROADCAST' ? 'campaign' : 'person'
	}
}
